/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Plausible_SrcInputs */

const en_admin_settings_fields_plausible_src = /** @type {(inputs: Admin_Settings_Fields_Plausible_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script Src`)
};

const zh_admin_settings_fields_plausible_src = /** @type {(inputs: Admin_Settings_Fields_Plausible_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚本地址`)
};

/**
* | output |
* | --- |
* | "Script Src" |
*
* @param {Admin_Settings_Fields_Plausible_SrcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_plausible_src = /** @type {((inputs?: Admin_Settings_Fields_Plausible_SrcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Plausible_SrcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_plausible_src(inputs)
	return zh_admin_settings_fields_plausible_src(inputs)
});
export { admin_settings_fields_plausible_src as "admin.settings.fields.plausible_src" }